module.exports = __webpack_public_path__ + "img/theme.d60e894e.svg";